import { useDependencies } from "./useDependencies";
import { useAuth } from "./useAuth";
import { useDocumentationArea } from "./useDocumentationArea";
import { DocumentationAreaNotFoundError } from "src/contexts/documentationArea/domain/errors/DocumentationAreaNotFoundError";
import { useDocumentationAreaMutation } from "./useDocumentationAreaMutation";

interface MutationFnProps {
  identityVerificationId: string;
  fileId: string;
}

export const useDiscardIdentityVerificationStagedFile = () => {
  const { token } = useAuth();
  const { documentationArea } = useDocumentationArea();
  const { documentationAreaController } = useDependencies();

  if (!documentationArea) throw new DocumentationAreaNotFoundError();

  const mutationFn = async ({ identityVerificationId, fileId }: MutationFnProps) => {
    return await documentationAreaController.discardIdentityVerificationStagedFile(
      token,
      documentationArea.getId(),
      documentationArea.getActor().getId(),
      identityVerificationId,
      fileId,
    );
  };

  const { mutate, isSuccess, isPending } = useDocumentationAreaMutation({
    mutationFn,
  });

  return {
    mutate,
    isSuccess,
    isPending,
  };
};
